import React from "react";
import { Box, Divider, Typography } from "digiwash-components";
import useNavigation from "../../hooks/useNavigation";
import CustomIcon from "../CustomIcon";
import { TouchableOpacity } from "react-native";
import BoxRatio from "../BoxRatio";

import {
  boxRatioWidth,
  suggestResponsiveBoxRatioForCategories,
} from "../../helpers/general";

function CategoriesItem(props) {
  let nav = useNavigation();
  let categories = suggestResponsiveBoxRatioForCategories();
  return (
    <>
      <Box
        style={{
          overflow: "hidden",
        }}
      >
        <Box py="l">
          <TouchableOpacity
            onPress={() => {
              nav.navigate("Services", { id: props.id });
            }}
          >
            <BoxRatio
              ratio="2:1.84"
              fixedWidth={boxRatioWidth({
                columns: categories.column,
                padding: categories.padding,
              })}
            >
              <Box
                style={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                }}
              >
                <CustomIcon icon={props.icon} width="100%" height="100%" />
              </Box>
            </BoxRatio>
            <Divider size="l" />
            <Typography color="common.black">{props.title}</Typography>
          </TouchableOpacity>
        </Box>
      </Box>
    </>
  );
}

export default CategoriesItem;
